import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ServicesTypes } from '../models/enums/services.enum';

@Injectable()
export class DocumentTypeService {
  documentTypes: Array<DocumentTypes>;

  constructor() {
    this.documentTypes = [
      {
        name: 'Cart. Identidade (RG)',
        hasFrontBack: true,
        initialState: 'front',
        frontImage: '/assets/images/documents/rg-verso.svg',
        backImage: '/assets/images/documents/rg-frente.svg'
      },
      {
        name: 'Ident. Estrangeiro (RNE)',
        hasFrontBack: false,
        initialState: 'front',
        frontImage: '/assets/images/documents/rne.svg',
        backImage: ''
      },
      {
        name: 'Certidão de Nasc. (antes 2009)',
        hasFrontBack: false,
        initialState: 'front',
        frontImage: '/assets/images/documents/certid-o-a-2009.svg',
        backImage: ''
      },
      {
        name: 'Certidão de Nasc. (a partir 2009)',
        hasFrontBack: false,
        initialState: 'front',
        frontImage: '/assets/images/documents/certid-o-d-2009.svg',
        backImage: ''
      },
      {
        name: 'Cart. Nac. Habil. (CNH)',
        hasFrontBack: true,
        initialState: 'front',
        frontImage: '/assets/images/documents/cnh-frente.svg',
        backImage: '/assets/images/documents/cnh-verso.svg'
      }
    ];
  }

  getDocumentTypes(services?: (keyof typeof ServicesTypes)[]): Array<DocumentTypes> {

    if (!services || services.includes(ServicesTypes.FUNDOS)) {
      return this.documentTypes;
    }

    return this.documentTypes.filter((s) => s.name.includes('RG'));
  }
}

export interface DocumentTypes {
  name: string;
  hasFrontBack: boolean;
  initialState: string;
  frontImage: string;
  backImage: string;
}
